import { Link } from "react-router-dom";
import type { Manga } from "@/mocks/mangaList";

interface MangaCardProps {
  manga: Manga;
}

export default function MangaCard({ manga }: MangaCardProps) {
  return (
    <Link
      to={`/article/${manga.latestChapterId}`}
      className="group block"
      title={`${manga.title}漫画免费在线阅读`}
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <img
          src={manga.cover}
          alt={`${manga.title}漫画封面`}
          title={`${manga.title}漫画`}
          className="h-52 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-foreground-950/60 px-2 py-0.5 text-xs text-background-50">
          {manga.status}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-primary-500 px-1.5 py-0.5 text-xs font-bold text-background-50">
          {manga.rating}
        </span>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent px-3 pb-2 pt-8">
          <p className="truncate text-xs text-background-50">{manga.latestChapter}</p>
        </div>
      </div>
      <h3 className="mt-2 truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
        {manga.title}
      </h3>
      <p className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
        <span className="truncate">{manga.author}</span>
        <span className="flex shrink-0 items-center gap-0.5">
          <i className="ri-eye-line text-foreground-400" aria-hidden="true" />
          {manga.views}
        </span>
      </p>
    </Link>
  );
}